import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule, ButtonWrapperModule, IconModule, TextFieldModule } from '../components';
import { StepModule } from '../components/step/step.module';
import { FeatureGuidePositionService } from './feature-guide-position.service';
import { FeatureGuideTooltipComponent } from './feature-guide-tooltip.component';
import { FeatureGuideTooltipService } from './feature-guide-tooltip.service';
import { FeatureGuidesDirective } from './feature-guides.directive';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    StepModule,
    ButtonWrapperModule,
    TextFieldModule,
    IconModule
  ],
  providers: [
    FeatureGuideTooltipService,
    FeatureGuidePositionService
  ],
  declarations: [
    FeatureGuideTooltipComponent,
    FeatureGuidesDirective
  ],
  exports: [
    FeatureGuidesDirective
  ]
})
export class FeatureGuideModule {
}
